import { GridToolbarContainer } from '@mui/x-data-grid';
import styled from '@emotion/styled';

export const CustomGridToolbarContainer = styled(GridToolbarContainer)`
  & .MuiButtonBase-root {
    color: black;
  }
`;
